import { useMemo } from "react";
import { injectIntl } from "react-intl";
import { UncontrolledTooltip } from "reactstrap";

import { useIsFlagged } from "../../../Base/Hooks/isFlagged";

import { getEventTimeForUpdatedDeletedEvents, sendEvent } from "../../../Base/Utilities/SendEvent";
import { getFlaggedReasonText, setFlaggedReason } from "../../../Base/Utilities/EventFlagging";

const Bookmark = (props) => {
  const { currentState, updateState, intl } = props;
  const { formatMessage } = intl;

  const playEvents = useMemo(() => {
    return props.eventStore.filter((ev) => ev.playId === currentState.modify.playId);
  }, [props.eventStore, currentState.modify?.playId]);

  const [isFlagged, flaggedReason] = useIsFlagged(currentState, playEvents);

  const _setFlagged = (flag) => {
    if (currentState.modify) {
      playEvents.forEach((event) => {
        event.eventTime = getEventTimeForUpdatedDeletedEvents(event);
        event.status = "updated";
        event.flagged = flag;
        let action = {
          action: "sendEvent",
          event: event,
          type: "custom",
        };
        sendEvent(action, props);
        if (!flag) {
          setFlaggedReason(currentState, updateState, event.eventId, undefined);
        }
      });
      let tempEvents = currentState.events;
      tempEvents.main.flagged = flag;
      updateState("events", tempEvents);
    }
  };

  return (
    <div className={"book-mark marked-" + isFlagged} id={"edit-book-mark"} onClick={() => _setFlagged(!isFlagged)}>
      {isFlagged && flaggedReason && (
        <UncontrolledTooltip target={`edit-book-mark`}>
          {getFlaggedReasonText(formatMessage, flaggedReason)}
        </UncontrolledTooltip>
      )}
      <span>
        {formatMessage({
          id: "bookmark",
          defaultMessage: "bookmark",
        })}
      </span>
      <i className="fas fa-bookmark"></i>
      <i className="star fas fa-star"></i>
    </div>
  );
};

export default injectIntl(Bookmark);
